import type { ReactNode } from "react";
import { motion } from "motion/react";
import { NoAutoAds } from "@/components/app/no-auto-ads";

export function LegalPage({
  title,
  intro,
  children,
}: {
  title: string;
  intro?: string;
  children: ReactNode;
}) {
  return (
    <main className="page-shell px-5 lg:px-8 pt-10">
      <NoAutoAds />
      <motion.header
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      >
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {intro ? (
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{intro}</p>
        ) : null}
      </motion.header>
      <div className="mt-6 space-y-4">{children}</div>
    </main>
  );
}

export function LegalCard({ heading, points }: { heading?: string; points: string[] }) {
  return (
    <section className="glass rounded-3xl p-5">
      {heading ? <h2 className="text-sm font-semibold">{heading}</h2> : null}
      <ul className={heading ? "mt-3 space-y-3" : "space-y-3"}>
        {points.map((point) => (
          <li key={point} className="flex gap-3 text-sm leading-relaxed text-muted-foreground">
            <span aria-hidden className="mt-2 size-1.5 shrink-0 rounded-full bg-primary/70" />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}